export const FIRST_PAGE = 1;

export const DEFAULT_PER_PAGE = 25;

export const MINIMUM_PAGES_FOR_PAGINATION = 2;
